import { Button, styled } from '@mui/material';

export const PageForm = styled('div')({
  width: '90%',
  maxWidth: '900px',
  margin: 'auto',
  display: 'flex',
  flexDirection: 'column',

  padding: '2em 2em 1em',
  marginTop: '1em',
  borderRadius: '1.5em',
  backgroundColor: '#FFFF',

  hr: {
    width: '90vw',
    maxWidth: '900px',
    position: 'relative',
    left: '-2em',
  },
});

export const FormButton = styled(Button)({
  float: 'right',
  ':disabled': {
    opacity: 0.6,
    cursor: 'not-allowed',
  },

  /* o seletor submitButton[disabled] é para navegadores que só suportam CCS2 */
  '[disabled]': {
    opacity: 0.6,
    cursor: 'not-allowed',
  },
});
